import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import {HeartHandshake,Utensils, Store} from "lucide-react";
import HeaderCartIcon from "./items/HeaderCartIcon";
import {useMediaQuery} from "@mui/material";
import {theme} from "../../../../config/design/theme";

function MenuTabs({style,global_menu}) {
    const location = useLocation();
    const [value, setValue] = React.useState(location.pathname);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleChange = (event, newValue) => {
        setStore(({
            global_menu:newValue
        }))
        navigate(`/${newValue}`);
        setValue(newValue);
    };

    return (
        <div style={{display:"flex",alignItems:'center',justifyContent:"space-between",width:"100%"}}>
            <Box style={style} className="top-menu-items">
                <Button
                    startIcon={<Utensils className="lucide-sm"/>}
                    color={global_menu === "restaurants" ? "primary" : 'text'}
                    onClick={(e) => handleChange(e,'restaurants')}
                >
                    {t('restaurants')}
                </Button>
                <Button
                    startIcon={<Store className="lucide-sm"/>}
                    color={global_menu === "markets" ? "primary" : 'text'}
                    onClick={(e) => handleChange(e,'markets')}
                >
                    {t('markets')}
                </Button>
                {/*<Button
                    startIcon={<HeartHandshake className="lucide-sm"/>}
                    color={global_menu === "charities" ? "primary" : 'text'}
                    onClick={(e) => handleChange(e,'charities')}
                >
                    {t('charities')}
                </Button>*/}
            </Box>
        </div>

    );
}
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
    global_menu: state.global_menu,
});
export default withStyles(Styles)(connect(mstp)(MenuTabs));